import { createContext, useContext } from 'react';

/** Lets content inside the message list steer its stick-to-bottom follow. */
interface AgentMessageListScrollValue {
  /**
   * Stops following new content to the bottom until the user scrolls back
   * down — for content that scrolls itself into view (e.g. an expanded card),
   * which the follow would otherwise yank away.
   */
  releaseStickToBottom: () => void;
  /**
   * Same as `releaseStickToBottom`, but a no-op while a turn is live, so
   * expanding content doesn't stop the view following the streaming answer.
   */
  releaseStickToBottomIfIdle: () => void;
  /**
   * Scrolls only the message list (never the page around it) so the element's
   * top is visible when it sits above the list viewport. Skipped while the
   * view is following a live turn.
   */
  revealElementTop: (element: HTMLElement) => void;
}

const AgentMessageListScrollContext = createContext<AgentMessageListScrollValue | null>(null);

/**
 * Reads the enclosing message list's scroll controls; null outside a list
 * (e.g. a card rendered standalone in tests or Storybook).
 *
 * @returns {AgentMessageListScrollValue | null} The scroll controls, if inside a list
 */
const useAgentMessageListScroll = (): AgentMessageListScrollValue | null => useContext(AgentMessageListScrollContext);

export { AgentMessageListScrollContext, useAgentMessageListScroll };
export type { AgentMessageListScrollValue };
